export default __webpack_public_path__ + "static/kbblogo-4884f9c96c006a891aa9f6eb069ff1dd.png";